import React, { useEffect } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Layout from "./components/Layout";

import ProtectedRoute from "./components/ProtectedRoute";
import ProtectedRouteByCompanyDetails from "./components/ProtectedRouteByCompanyDetails";
import ProtectedRouteByYear from "./components/ProtectedRouteByYear";

import Login from "./pages/Login";
import Signup from "./pages/Signup";
import ForgetPassword from "./pages/ForgetPassword";
import ResetPassword from "./pages/ResetPassword";

import DynamicProtectedRoute from "./components/DynamicProtectedRoute";

import { useDispatch } from "react-redux";
import { loginSuccess } from "./redux/slices/authSlice";
import Notification from "./hooks/notification";
import routes from "./routes";

function App() {
  const dispatch = useDispatch();

  useEffect(() => {
    const user = localStorage.getItem("user");
    const token = localStorage.getItem("token");
  
    if (token && user) {
      try {
        const parsedUser = JSON.parse(user);
        dispatch(loginSuccess({ user: parsedUser, token }));
      } catch (error) {
        console.error("Failed to parse user data:", error);
        localStorage.removeItem("user");
      }
    }
  }, []);
  

  return (
    <div>
      <Router>
        <Routes>
          <Route path="/signup" element={<Signup />} />
          <Route path="/login" element={<Login />} />
          <Route path="/forgetpassword" element={<ForgetPassword />} />
          <Route path="/reset-password/:token" element={<ResetPassword />} />

          <Route
            path="/*"
            element={
              <ProtectedRoute>
                <Layout>
                  <Routes>
                    {routes.map((item, i) => (
                      <Route
                        key={i}
                        path={item.path}
                        element={
                          <DynamicProtectedRoute protections={item.protections}>
                            {item.element}
                          </DynamicProtectedRoute>
                        }
                      />
                    ))}
                  </Routes>
                </Layout>
              </ProtectedRoute>
            }
          />
        </Routes>
      </Router>
      <Notification />
    </div>
  );
}

export default App;
